// react
import React from 'react';

// components
import { NavDrawer, type LinkItem } from '@/pwa/molecules/NavDrawer/NavDrawer';
import { type AccountInfoProps } from '@/pwa/atoms/AccountInfo/AccountInfo';
import { StackLayout } from '@/pwa/templates/StackLayout/StackLayout';

export interface ChromeTemplateProps {
  links: LinkItem[];
  accountInfoProps?: AccountInfoProps;
  activePath?: string;
}

/**
 * ChromeTemplate renders NavDrawer for root-level pages and an animated
 * full-screen overlay for stacked pages.
 *
 * Root content slides left and fades when a stacked page enters.
 * Routes with `handle: { stack: true }` render as position: fixed overlays
 * above the nav chrome with slide + opacity transitions.
 * Root-to-root navigation uses a fade transition.
 */
export const ChromeTemplate = ({
  links,
  accountInfoProps,
  activePath,
}: ChromeTemplateProps) => {
  return (
    <StackLayout freezeOnRootStack>
      {(outlet) => (
        <NavDrawer
          links={links}
          accountInfoProps={accountInfoProps}
          activePath={activePath}
        >
          {outlet}
        </NavDrawer>
      )}
    </StackLayout>
  );
};

ChromeTemplate.displayName = 'ChromeTemplate';
export default ChromeTemplate;
